import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineSmallOneLineWithTextProps } from './types';
import { isNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';

export const HeadlineSmallOneLineWithText = ({
  header,
}: HeadlineSmallOneLineWithTextProps) => {
  if (isNil(header)) return null;

  return (
    <Flex.Row
      padding={{ horizontal: 16, vertical: 16 }}
      justifyContent={'space-between'}
      alignItems={'center'}
      testID={header.item.title}
    >
      <Typography type="h5" color="content_primary">
        {header.item.title}
      </Typography>

      {header.item.text && (
        <HTMLText type="body2" color="content_secondary">
          {header.item.text}
        </HTMLText>
      )}
    </Flex.Row>
  );
};
